import React from 'react';

const HeaderLayout = ({  tab,setSelectNetwork,User }) => {
  return (
    <div className=' w-[95%] sticky top-0 '>
      <div className=''>
        <div className='bg-black border-b border-white/25 w-full p-5 font-inter'>
          <div className='w-full flex justify-between items-center'>
            <div className='flex items-center gap-3'>
              <div>
                <p className='font-medium text-sm lg:block hidden'>
                  <span className='text-white/50'>User</span> / {tab}
                </p>
              </div>
            </div>

            <div className='flex gap-3 items-center'>
              <button onClick={() => setSelectNetwork(true)} className="flex items-center gap-3">
                <p className="font-semibold font-Artemus">Welcome !!, {User.Name}</p>
                <img className="w-10 h-10 rounded-full"
                  src="/assets/Profile/Sendprofile1.svg"></img>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default HeaderLayout;